import { matterDetailQueryKey } from "@/lib/data/static/matter-query-key";
import { Slideover } from "@/components/ui";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import type { Matter } from "@/lib/types";
import type { APIResponse } from "@/lib/types/APIResponse";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MatterEmailDetailContent } from "./MatterEmailDetailContent";

interface ViewMatterEmailSlideoverProps {
  title: string;
  description?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  matterId: string;
  matterEmailId: string;
}

export const ViewMatterEmailSlideover = ({
  title,
  description,
  open,
  setOpen,
  matterId,
  matterEmailId,
}: ViewMatterEmailSlideoverProps) => {
  const queryClient = useQueryClient();
  const cachedMatter = queryClient.getQueryData<APIResponse<Matter>>(
    matterDetailQueryKey(matterId),
  );
  const { data: fetchedMatter } = useQuery({
    ...retrieveMatterQueryOptions(matterId),
    enabled: Boolean(matterId) && !cachedMatter,
  });
  const matter = (cachedMatter ?? fetchedMatter)?.data;

  return (
    <Slideover
      title={title}
      description={description}
      open={open}
      setOpen={setOpen}
      size="large"
      enabledSections={["notes", "tasks", "references", "events"]}
      editing
      matter={matter}
      itemKey="matterEmailId"
      itemId={matterEmailId}
      subItem={{ id: matterEmailId, type: "email" }}
      initialTab="details"
    >
      <MatterEmailDetailContent
        matterId={matterId}
        matterEmailId={matterEmailId}
        matter={matter}
        onDeleteSuccess={() => {
          setOpen(false);
        }}
      />
    </Slideover>
  );
};
